import { axios } from 'src/api'
import { withAbortController } from 'src/types/withAbortController.type'

export interface ApiCheckCouponParamsData {
  userToken: string
  couponCode: string
}

export interface ApiCheckCouponParams extends withAbortController {
  serverPath: string
  data: ApiCheckCouponParamsData
}

export interface ApiCheckCouponResponse {
  type: string
  errorList: any[]
  ok: boolean
  status: string
  statusType: string
  valid: boolean
}

export const apiCheckCoupon = async ({ controller, serverPath, data }:ApiCheckCouponParams) => {
  return axios.post<ApiCheckCouponResponse>(`https://${serverPath}/sialdPMS/web/resourcescrossorigin/coupon/checkcouponcode`, data, {
    signal: controller?.signal
  })
}
